import React from "react";
import { useTranslation } from "react-i18next";
import { GroupList } from "@core/components/groups";

/**
 * Page de gestion des groupes pour les sondages de dates
 * Utilise le composant GroupList existant qui contient déjà le CRUD complet
 */
const GroupsPage: React.FC = () => {
  const { t } = useTranslation("forms");
  return (
    <div className="min-h-screen-safe bg-gray-50 dark:bg-gray-900">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* En-tête de la page */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            {t("groups.page.title")}
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            {t("groups.page.description")}
          </p>
        </div>

        {/* Liste des groupes avec CRUD complet */}
        <GroupList />
      </div>
    </div>
  );
};

export default GroupsPage;
